module.exports = __webpack_public_path__ + "components/flag/static/square/gb-nir-b3b355e5f52ace4bf035f7c6dd4a7e84.svg";